import { Outlet } from 'react-router-dom'
import { Typography } from "@/components/app"
import Logo from "../icons/Logo"
import { Link } from 'react-router-dom'

export default function AuthLayout() {
  return (
    <div className="w-full  ">
      <div className="h-screen md:grid md:grid-cols-2 gap-6 p-6" >
        <div className="relative hidden md:block rounded-3xl overflow-hidden">
          <img
            src="/images/login-img.webp"
            alt="Jewelry model"
            className="w-full h-full object-cover object-top"
          />

          {/* Caption */}
          <div className="absolute bottom-6 left-5 right-5">
            <div className="bg-card/50 backdrop-blur-sm rounded-2xl p-5">
              <Typography variant="h3" className="font-bold">
                Manage Luxury With Precision. {' '}
                <span className="font-normal">
                  Access your dashboard to oversee collections, orders, customers,
                and inventory – all in one secure place.
                </span>
              </Typography>
            </div>
          </div>
        </div>

        <div className="overflow-hidden h-full relative">
          <div className="rounded-3xl md:bg-gradient-card h-full overflow-auto flex flex-col justify-center items-center md:p-6 md:border md:border-border scrollbar-thin">

            <div className="absolute top-0 right-0 w-40 h-40 hidden md:block" >
              <img src={'/images/Ellipse.svg'} width={160} height={160} alt="ellipsis" className="w-40 h-40" />
            </div>
            <div className="absolute left-0 -bottom-4 hidden md:block  w-40 h-40" >
              <img src={'/images/Ellipse.svg'} width={160} height={160} alt="ellipsis" className="w-40 h-40 rotate-180" />
            </div>

            <div className="max-w-[520px] w-full">
              <div className="flex justify-center items-center gap-2 mb-8">
                <Link to={'/'} >
                  <Logo />
                </Link>
              </div>
              <div className="p-5 md:p-0 border border-border md:border-0 bg-gradient-card md:bg-transparent rounded-xl md:rounded-none">
              <Outlet />
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  )
}
